<template>
  <div class="heading">
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'Heading',
  props: {
    text: String,
  },
};
</script>

<style scoped>
.heading {
  color: #9a9899;
  font-size: 1.3em;
  font-weight: bold;
  text-align: left;
}
</style>
